import moment from 'moment';
import {
  faArrowTrendUp,
  faArrowTrendDown,
  faMinus,
} from '@fortawesome/free-solid-svg-icons';
import { DateRange } from './types';

export const DEFAULT_DATE_RANGE: DateRange = {
  startDate: moment().subtract(30, 'days'),
  endDate: moment(),
};

export const DEFAULT_LIMIT = 10;

export const LIMIT_OPTIONS = [
  { value: 5, label: 'Top 5' },
  { value: 10, label: 'Top 10' },
  { value: 20, label: 'Top 20' },
  { value: 50, label: 'Top 50' },
] as const;

export const TREND_TYPES = {
  UP: 'up',
  DOWN: 'down',
  NEUTRAL: 'neutral',
} as const;

export const COLORS = {
  LIGHT: {
    BACKGROUND: '#F7FAFC',
    CARD_BG: '#ffffff',
    TEXT_PRIMARY: '#1A202C',
    TEXT_SECONDARY: '#718096',
    TEXT_TERTIARY: '#A0AEC0',
    BORDER: '#E2E8F0',
    SUCCESS: '#48BB78',
    ERROR: '#F56565',
    WARNING: '#ED8936',
    INFO: '#4299E1',
    HOVER: '#EDF2F7',
  },
  DARK: {
    BACKGROUND: '#1A202C',
    CARD_BG: '#2D3748',
    TEXT_PRIMARY: '#ffffff',
    TEXT_SECONDARY: '#CBD5E0',
    TEXT_TERTIARY: '#A0AEC0',
    BORDER: '#4A5568',
    SUCCESS: '#68D391',
    ERROR: '#FC8181',
    WARNING: '#F6AD55',
    INFO: '#63B3ED',
    HOVER: '#4A5568',
  },
} as const;

export const BORDER_COLORS = {
  PRIMARY: '#4299E1',
  SUCCESS: '#48BB78',
  WARNING: '#ED8936',
  ERROR: '#F56565',
} as const;

export const TREND_ICON_CONFIG: Record<string, { icon: any; color: string }> = {
  [TREND_TYPES.UP]: {
    icon: faArrowTrendUp,
    color: '#48BB78',
  },
  [TREND_TYPES.DOWN]: {
    icon: faArrowTrendDown,
    color: '#F56565',
  },
  [TREND_TYPES.NEUTRAL]: {
    icon: faMinus,
    color: '#A0AEC0',
  },
} as const;
